module.exports = require("d3-scale");


/*****************
 ** WEBPACK FOOTER
 ** external "d3-scale"
 ** module id = 94
 ** module chunks = 0
 **/